// packages/api-client/src/services/threadsService.ts
import { getApiClient } from '../client';
import { handleApiError } from '../utils/handleApiError';
import type { ServiceResponse, UUID } from '@dopomogai/types';

export interface ThreadCreateResponse {
  parent_conversation_id: UUID;
  child_conversation_id: UUID;
  parent_message_index: number;
  message_count?: number;
}

export interface ThreadSummary {
  id: UUID;
  parent_conversation_id: UUID;
  parent_message_index: number;
  child_conversation_id: UUID;
  created_at: string;
}

/**
 * Threads API
 * - Create a thread from a parent conversation anchored at a message index
 * - List threads for a parent conversation
 */
export const threadsService = {
  createThread: (
    conversationId: UUID,
    payload: { message_index: number; new_agent_id?: UUID | null }
  ): ServiceResponse<ThreadCreateResponse> => {
    return getApiClient()
      .post<ThreadCreateResponse>(`/conversations/${conversationId}/threads`, payload)
      .then((res) => res.data)
      .catch((err) => handleApiError(err, 'creating thread'));
  },

  listThreads: (conversationId: UUID): ServiceResponse<ThreadSummary[]> => {
    return getApiClient()
      .get<ThreadSummary[]>(`/conversations/${conversationId}/threads`)
      .then((res) => res.data)
      .catch((err) => handleApiError(err, 'listing threads'));
  },
};